import { formatDistanceToNow } from 'date-fns'

export const formatUtcTimestamp = (
  value: string,
  includeMilliseconds: boolean = false,
  includeUtc: boolean = false
) => {
  if (!value || value === null || value === '' || value === undefined) return 'Unknown'
  const valueWithMilliseconds = includeMilliseconds
    ? value.replace('[UTC]', '').replace('T', ' ').replace('Z', '')
    : value.replace('[UTC]', '').replace('T', ' ').replace('Z', '').split('.')[0]
  const updatedValue = includeMilliseconds ? valueWithMilliseconds : valueWithMilliseconds.split('.')[0]
  return includeUtc ? updatedValue + ' (UTC)' : updatedValue
}

export const timeSince = (stringData: string) => {
  if (!stringData) return 'N/A'
  const date = new Date(stringData)
  return formatDistanceToNow(date, { addSuffix: true })
}

export const formatEpochToIverifyDate = (epochTime: number) => {
  const date = new Date(epochTime)
  const dateString = date.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: '2-digit' })
  const timeString = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false })
  return `${dateString} @ ${timeString}`
}

export const calculateTimeLeft = (gracePeriod?: string) => {
  const now = new Date()
  const gracePeriodDate = new Date(gracePeriod ?? '')
  const diff = gracePeriodDate.getTime() - now.getTime()
  return formatDaysHoursMinutes(diff)
}

export const calculateTimeTo = (timeInMins: number) => {
  const timeInMilliseconds = timeInMins * 60 * 1000
  return formatDaysHoursMinutes(timeInMilliseconds, true)
}

const formatDaysHoursMinutes = (diff: number, short: boolean = false) => {
  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

  let result = ''

  if (days > 0) {
    result += `${days} ` + (short ? 'd ' : 'days ')
  }

  if (hours > 0) {
    result += `${hours} ` + (short ? 'h ' : 'hours ')
  }

  if (minutes > 0 || result === '') {
    result += `${minutes} ` + (short ? 'm' : 'minutes')
  }

  return result.trim()
}
